var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeNavIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home-icon",
    transform: "translate(-364 -24)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_676",
    "data-name": "Rectangle 676",
    width: 16,
    height: 16,
    transform: "translate(364 24)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "home-icon-2",
    "data-name": "home-icon",
    d: "M13,14.451H3.667A.667.667,0,0,1,3,13.784v-6H1L7.885,1.525a.667.667,0,0,1,.9,0l6.885,6.259h-2v6A.667.667,0,0,1,13,14.451ZM4.333,13.117h8V6.555l-4-3.636-4,3.636Zm2-6h4v4h-4ZM7.667,8.451V9.784H9V8.451Z",
    transform: "translate(363.667 23.549)",
    fill: "#09c"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeNavIcon);
export default __webpack_public_path__ + "static/media/home-nav-icon.c2a15b7033d0d26d40107b1377de5321.svg";
export { ForwardRef as ReactComponent };